import { UNDEFINED_CLIENT_ID } from "../../users";
import { ChangeRoomSupervisionMessage, NewRoomHostMessage } from "flavr-common";
import { busService } from "../../bus";
class PeerService {
    constructor() {
        this.connection = busService.connection("PeerService");
        this._clientId = UNDEFINED_CLIENT_ID;
        this._hostClientId = UNDEFINED_CLIENT_ID;
        this.handleChangeRoomSupervisionMessage = (msg) => {
            this._hostClientId = msg.hostClientId;
        };
        this.handleNewRoomHostMessage = (msg) => {
            this._hostClientId = msg.hostClientId;
        };
        this.connection.subscribeByType(ChangeRoomSupervisionMessage, this.handleChangeRoomSupervisionMessage);
        this.connection.subscribeByType(NewRoomHostMessage, this.handleNewRoomHostMessage);
    }
    /**
     * Client id of this client
     */
    get clientId() {
        return this._clientId;
    }
    /**
     * Client id of the host. The host is usually the peer that connected to the session first. Therefore this client
     * and the host client can be the same in some cases.
     */
    get hostClientId() {
        return this._hostClientId;
    }
    setLocalClientId(clientId) {
        this._clientId = clientId;
    }
}
export const peerService = new PeerService();
